import(/* webpackMode: "eager" */ "/app/app/_components/main-page/main-page.js")